export default __webpack_public_path__ + "static/media/screenBlock1.cc285d7d.jpg";